import { createAsyncThunk } from '@reduxjs/toolkit';
import isNil from 'lodash/isNil';
import { createGrowl } from './rootHelpers';
// Not from './rootReducer', which imports this file: see rootReducerName.js.
import { reducerName } from './rootReducerName';

const thunk = (name, cb) => createAsyncThunk(`${reducerName}/${name}`, cb);
const growl = (name, type, defaultTtl) =>
  thunk(name, async ({ props, groupId }, thunkApi) => {
    props =
      typeof props === 'string'
        ? { message: props, ...(isNil(defaultTtl) ? {} : { ttlSeconds: defaultTtl }) }
        : props;
    return {
      growl: createGrowl(groupId, type, props, thunkApi),
    };
  });
export const errorGrowl = growl('errorGrowl', 'error');
export const infoGrowl = growl('infoGrowl', 'info');
export const successGrowl = growl('successGrowl', 'success', 10);
// SURF-4809: added for the CSV import dialog, which is the one screen that reports a partial
// success. `GrowlItem` renders `alert-${type}`, so this lands on `.alert-warning` (main.css)
// like the Angular `growl.warning` it replaces.
export const warningGrowl = growl('warningGrowl', 'warning');
